const env = {
  // CAMPEONATO: 'Gold-2022-2',
  CAMPEONATO: 'Sapphire-2024-1',
  PREFIX_JOGADORES: '20241S-'
};

export default env;
